export const IMG = {
  logo: "/images/logo.png",
  s1: "/images/s1.jpg",
  s2: "/images/s2.jpg",
  s3: "/images/s3.jpg",
  concierge: "/images/concierge.jpg",
  online: "/images/online.jpg",
};

export const CONTACT = {
  phone: "[+44 phone number]",
  triage: "[24h triage line]",
  email: "[enquiries@email-address]",
};

export const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/approach", label: "Approach", id: "approach" },
  { to: "/immediate-support", label: "Immediate Support", id: "immediate-support" },
  { to: "/locations", label: "Locations", id: "locations" },
  { to: "/client-stories", label: "Client Stories", id: "client-stories" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export const SLIDES = [
  {
    eyebrow: "Post-Traumatic Growth",
    lines: ["Overcome Trauma.", "Achieve True", "Post-Traumatic Growth."],
    sub: "Bespoke, 100% drug-free trauma recovery for high-performing individuals. Delivered confidentially worldwide—online, in-person, or at private retreat locations.",
    image: IMG.s1,
    primary: { label: "Book a Confidential Consultation", to: "/contact" },
    secondary: { label: "Immediate Post-Incident Support", to: "/immediate-support" },
  },
  {
    eyebrow: "Private Retreat · Andalusia, Spain",
    lines: ["Recovery, held", "far from the", "everyday."],
    sub: "A private mountain retreat in Andalusia for clients who want complete distance from daily life while they do the deepest work.",
    image: IMG.s2,
    primary: { label: "Book a Confidential Consultation", to: "/contact" },
    secondary: { label: "Explore Locations", to: "/locations" },
  },
  {
    eyebrow: "No. 2 Harley Street · London",
    lines: ["Root-cause", "recovery, not", "symptom management."],
    sub: "Backed by 14 years of clinical data demonstrating a 98.4% reduction in PTSD symptoms (DSM-5 / PCL-5 scale).",
    image: IMG.s3,
    primary: { label: "Book a Confidential Consultation", to: "/contact" },
    secondary: { label: "Our Approach", to: "/approach" },
  },
];

export const BADGES = [
  { value: 14, suffix: "", decimals: 0, label: "Year Track Record", note: "Proven clinical record" },
  { value: 98.4, suffix: "%", decimals: 1, label: "Symptom Reduction", note: "Measured on PCL-5" },
  { value: 100, suffix: "%", decimals: 0, label: "Drug-Free", note: "No medication, ever" },
];

export const MARQUEE = [
  "Post-Traumatic Growth",
  "100% Drug-Free",
  "Root-Cause Recovery",
  "Confidential Worldwide",
  "No. 2 Harley Street",
  "Andalusia",
];

export const COMPARISON = {
  standard: {
    title: "Standard therapy",
    sub: "CBT · EMDR · Counselling",
    points: [
      "Focuses on managing symptoms day to day",
      "Teaches coping strategies to live alongside the memory",
      "The emotional charge of the memory often remains",
      "Progress can feel open-ended, with no defined outcome",
    ],
  },
  habitreat: {
    title: "Habitreat",
    sub: "Root-cause · Drug-free · PTG",
    points: [
      "Works on the root cause, not only the symptoms",
      "Eliminates the emotional attachment to traumatic memories",
      "100% drug-free, from first session to last",
      "Outcome-focused: true Post-Traumatic Growth",
    ],
  },
};

export const PROTOCOLS = [
  { n: "01", name: "Education", text: "Learning that the psychological impact of trauma is a normal response, and realizing that growth is possible." },
  { n: "02", name: "Regulation", text: "Utilizing wellness practices to manage thoughts and emotions, moving from reactive anxiety to calm reflection." },
  { n: "03", name: "Disclosure", text: "Sharing the traumatic experience and its impact out loud with trusted, non-judgmental people." },
  { n: "04", name: "Story (Narrative)", text: "Rebuilding core beliefs and intentionally writing a new, forward-looking life chapter." },
  { n: "05", name: "Service", text: "Using one's own hard-won wisdom and story to help others who are going through similar struggles." },
];

export const LOCATIONS = [
  {
    id: "online",
    tab: "Online",
    title: "Online Confidential Sessions",
    region: "Worldwide",
    image: IMG.online,
    text: "Private, encrypted sessions wherever you are in the world, scheduled around your commitments and time zone.",
    points: ["Available in every time zone", "Discreet scheduling", "Same practitioner throughout"],
  },
  {
    id: "harley-street",
    tab: "Harley Street",
    title: "No. 2 Harley Street",
    region: "London, United Kingdom",
    image: IMG.s3,
    text: "In-person sessions at No. 2 Harley Street, at the heart of London's medical district.",
    points: ["Private, in-person sessions", "Central London", "Discreet arrival on request"],
  },
  {
    id: "andalusia",
    tab: "Andalusia",
    title: "Mountain Retreat",
    region: "Andalusia, Spain",
    image: IMG.s2,
    text: "A private mountain retreat for clients who want complete distance from daily triggers while they recover.",
    points: ["Immersive private stays", "Away from everyday triggers", "Total anonymity"],
  },
  {
    id: "concierge",
    tab: "Your Residence",
    title: "Private Residence / Concierge",
    region: "Global",
    image: IMG.concierge,
    text: "Your practitioner comes to you — at your home, your hotel or a location of your choosing, anywhere in the world.",
    points: ["Delivered at your location", "Worldwide travel", "Arranged with full discretion"],
  },
];

const LOREM_A = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Cras mattis consectetur purus sit amet fermentum. Donec ullamcorper nulla non metus auctor fringilla.";
const LOREM_B = "Vestibulum id ligula porta felis euismod semper. Maecenas sed diam eget risus varius blandit sit amet non magna. Nullam quis risus eget urna mollis ornare vel eu leo. Aenean lacinia bibendum nulla sed consectetur.";
const LOREM_C = "Curabitur blandit tempus porttitor. Etiam porta sem malesuada magna mollis euismod. Sed posuere consectetur est at lobortis. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.";

export const STORIES = [
  {
    id: "client-a",
    code: "Client A",
    profile: "C-suite executive",
    setting: "Online · Worldwide",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing.",
    quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
    excerpt: LOREM_A,
    body: [LOREM_A, LOREM_B, LOREM_C],
  },
  {
    id: "client-b",
    code: "Client B",
    profile: "Elite athlete",
    setting: "Mountain Retreat · Andalusia",
    title: "Integer posuere erat a ante venenatis dapibus.",
    quote: "Maecenas faucibus mollis interdum. Vivamus sagittis lacus vel augue laoreet.",
    excerpt: LOREM_B,
    body: [LOREM_B, LOREM_C, LOREM_A],
  },
  {
    id: "client-c",
    code: "Client C",
    profile: "Actor",
    setting: "No. 2 Harley Street · London",
    title: "Donec ullamcorper nulla non metus auctor fringilla.",
    quote: "Nullam id dolor id nibh ultricies vehicula ut id elit. Cras justo odio, dapibus ac facilisis.",
    excerpt: LOREM_C,
    body: [LOREM_C, LOREM_A, LOREM_B],
  },
];

export const FAQS = [
  {
    q: "I've tried CBT or EMDR and it didn't work. How is Habitreat different?",
    a: "Standard approaches tend to focus on managing symptoms. Habitreat works on the root cause, removing the emotional attachment to the traumatic memory itself — 100% drug-free — so the goal is not coping, but true Post-Traumatic Growth.",
  },
  {
    q: "How quickly can treatment begin after an acute event?",
    a: "Our Immediate Post-Trauma Service (PTS, Not PTSD) is designed for same-day or acute intervention, within hours or days of an incident, to stop PTSD before it develops. Use the immediate support form or call the triage line.",
  },
  {
    q: "How is total confidentiality handled for high-profile clients?",
    a: "Every engagement is handled with complete discretion — from how you first contact us to where and how sessions take place, online, at No. 2 Harley Street, at our Andalusia retreat or at a private location of your choosing. Specific confidentiality arrangements can be discussed at your consultation.",
  },
  {
    q: "Is the treatment really drug-free?",
    a: "Yes. Habitreat's recovery is 100% drug-free from the first session to the last.",
  },
];

export const FORMATS = [
  { id: "online", label: "Online", detail: "Confidential session, worldwide" },
  { id: "harley-street", label: "Harley Street", detail: "No. 2 Harley Street, London" },
  { id: "andalusia", label: "Andalusia", detail: "Mountain Retreat, Spain" },
];

export const TIME_SLOTS = ["08:00", "09:00", "10:00", "11:00", "12:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00"];

export const TIMEZONES = [
  { id: "Europe/London", label: "London (GMT/BST)" },
  { id: "Europe/Madrid", label: "Madrid / Paris (CET)" },
  { id: "America/New_York", label: "New York (ET)" },
  { id: "America/Los_Angeles", label: "Los Angeles (PT)" },
  { id: "Asia/Dubai", label: "Dubai (GST)" },
  { id: "Asia/Singapore", label: "Singapore (SGT)" },
  { id: "Asia/Hong_Kong", label: "Hong Kong (HKT)" },
  { id: "Australia/Sydney", label: "Sydney (AET)" },
];
